// import { auth } from '@/auth/hyper-auth'
import { PROVIDED_SERVICES, BASE_SERVICES } from '@/service'
import { getCurrentInstance, computed } from '@vue/composition-api'
import utils from '@/auth/utils'

export default function useAvailableServices () {
    const vm = getCurrentInstance().proxy
    const store = vm.$store
    const serviceGroups = computed(() => store.getters.authServiceGroups)
    const authUserInfo = computed(() => store.getters.authUserInfo)
    const projects = computed(() => store.getters.projects)
    const myOwnProjects = computed(() => store.getters.myOwnProjects)
    const additionalProjects = computed(() => store.getters.additionalProjects)
    const availableService = computed(() => {
        if (projects.value.length || myOwnProjects.value.length || additionalProjects.value.length) {
            return serviceGroups.value
        } else {
            return serviceGroups?.value?.filter(service => service.name === 'billing-admin')
        }
    })

    const availableServicesHeader = {
        header: 'Available Services'
    }
    const availableServicesList = computed(() => availableService.value.map(service => {
        return {
            title: service.name.toUpperCase(),
            domain: service.domain,
            email: authUserInfo.value.email,
            href: '#',
            icon: 'LinkIcon',
            tag: `${service.name === 'notify' ? 'new' : ''}`,
            tagVariant: 'primary'
        }
    }))
    const data = computed(() => utils.getUserRights())
    const availableServices = computed(() => data.value.filter(service => PROVIDED_SERVICES[service.serviceName])
        .map(service => PROVIDED_SERVICES[service.serviceName])
        .concat(BASE_SERVICES.default)
        .concat(availableServicesList.value.length ? [availableServicesHeader] : [])
        .concat(availableServicesList.value)
        .sort((a, b) => a.order - b.order))

    return {
        availableServices
    }
}
